import { purchaseTypeDict } from '@/dictionary/project/common'
import useReviewOnlineInquiry from '@/components/online-review/hooks/useReviewOnlineInquiry'
import useReviewOnlineNegotiation from '@/components/online-review/hooks/useReviewOnlineNegotiation'

function useReviewOrder() {
  const isNegotiation = purchaseType =>
    purchaseType === purchaseTypeDict.NEGOTIATION.value

  /**
   * 获取评审采购单分页列表
   */
  const getOrderPage = ({ purchaseType, params }) => {
    if (isNegotiation(purchaseType)) {
      return useReviewOnlineNegotiation().getOrderPage(params)
    }
    return useReviewOnlineInquiry().getOrderPage(params)
  }

  return {
    getOrderPage,
    isNegotiation
  }
}

export default useReviewOrder
